/**
 * ContentGuard — restriction de contenu activable PAR UTILISATEUR.
 *
 * S'active uniquement pour les comptes dont `content_protection === true`
 * (réglage posé par un admin dans la gestion des utilisateurs). Désactivé par
 * défaut : aucun utilisateur n'est gêné tant qu'un admin ne l'a pas coché.
 *
 * Effet (dissuasion anti-copie, SANS filigrane) : blocage de la sélection, du
 * copier/couper, du clic droit, du glisser-déposer et des raccourcis
 * DevTools / enregistrer / imprimer. Les champs de saisie restent utilisables.
 *
 * Limite assumée : aucune techno web n'empêche une capture d'écran système ;
 * c'est une mesure de dissuasion, pas un coffre-fort.
 */
import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import './ContentGuard.css';

export default function ContentGuard() {
  const { user } = useAuth();
  const restricted = !!(user && user.content_protection);

  useEffect(() => {
    if (!restricted) return undefined;
    document.body.classList.add('ldws-content-restricted');

    const inEditable = (el) =>
      !!(el && el.closest && el.closest('input, textarea, select, [contenteditable="true"], [contenteditable=""]'));

    const blockOutsideEditable = (e) => {
      if (!inEditable(e.target)) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    const onDragStart = (e) => e.preventDefault();
    const onKeyDown = (e) => {
      const key = (e.key || '').toLowerCase();
      const ctrl = e.ctrlKey || e.metaKey;
      if (key === 'f12') return e.preventDefault();
      if (ctrl && e.shiftKey && ['i', 'j', 'c'].includes(key)) return e.preventDefault();
      if (ctrl && ['u', 's', 'p'].includes(key)) return e.preventDefault();
      if (ctrl && ['c', 'x', 'a'].includes(key) && !inEditable(e.target)) return e.preventDefault();
      return undefined;
    };

    const opts = true;
    document.addEventListener('copy', blockOutsideEditable, opts);
    document.addEventListener('cut', blockOutsideEditable, opts);
    document.addEventListener('contextmenu', blockOutsideEditable, opts);
    document.addEventListener('selectstart', blockOutsideEditable, opts);
    document.addEventListener('dragstart', onDragStart, opts);
    document.addEventListener('keydown', onKeyDown, opts);

    return () => {
      document.body.classList.remove('ldws-content-restricted');
      document.removeEventListener('copy', blockOutsideEditable, opts);
      document.removeEventListener('cut', blockOutsideEditable, opts);
      document.removeEventListener('contextmenu', blockOutsideEditable, opts);
      document.removeEventListener('selectstart', blockOutsideEditable, opts);
      document.removeEventListener('dragstart', onDragStart, opts);
      document.removeEventListener('keydown', onKeyDown, opts);
    };
  }, [restricted]);

  return null;
}
